import React, { memo, useState, useEffect } from 'react'
import { setPageName } from '../../../../redux'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { getData } from '../../../../assets/scripts/GeneralFunctions'
import NewMessageTitle from './child/NewMessageTitle'

function SmsInfo() {
  const [sms, setSms] = useState({})

  let { smsId } = useParams()

  const dispatch = useDispatch()

  useEffect(() => {
    async function fetchData() {
      dispatch(setPageName('sms'))
      let api_result = await getData(`admin/sms/${smsId}`, 'get', {}, true)
      if (api_result) {
        if (api_result?.status === 200) {
          let result_data = api_result?.data
          setSms(result_data?.sms)
        }
      }
    }

    fetchData()
  }, [])

  return (
    <>
      <NewMessageTitle title={'جزئیات'} />
      <div className="mt-12">
        <p className="text-link my-2 dark:text-gray-200">گیرنده پیامک ( دسته بندی) </p>
        <div className="flex">
          {sms?.receivers?.map((receiver, index) => {
            return (
              <div
                key={index}
                className="flex justify-center items-center font-medium m-1 dark:border-gray-700 dark:bg-slate-800 p-4 bg-light-blue rounded-lg border border-input-border w-fit h-16"
              >
                <div className="text-bold text-lg font-normal leading-none flex-initial dark:text-slate-200">
                  {receiver}
                </div>
              </div>
            )
          })}
        </div>
        <div className="mt-12">
          <p className="my-4 dark:text-gray-200">متن پیامک</p>
          <p className="bg-white p-4 border-input-border border dark:border-gray-700 text-main bg-white rounded-lg h-28 min-h-min dark:bg-slate-800 dark:text-slate-200">
            {sms?.message}
          </p>
        </div>
      </div>
    </>
  )
}

export default memo(SmsInfo)
